export default {
  checkout_order_id: '收银台订单号',
  attempts: '尝试次数',
  check_transactions: '查看交易',
  customer_name: '客户名称',
  customer_email: '客户邮箱',
  customer_mobile: '客户手机',
  checkout_details: '收银台订单详情'
}
